import * as React from 'react';

// Plain checkmark (stroke). Defaults to currentColor so it inherits/accepts a tint (e.g. green
// for a confirm action); pass `color` to set it explicitly.
export default ({ color = 'currentColor' } = {}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.5 7.5L10.5 15.5L7 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
